type MergeProps<T> = (src: T, dist: T, opts?: { concat: boolean }) => T;

const merge = <T>(
  src: T, dist: T, opts?: { concat: boolean; }
) => {
  if (null == src || typeof src !== "object") return dist;
  if (null == dist || typeof dist !== "object") return src;
  const isObject = (obj: T) => obj && typeof obj === 'object' && !Array.isArray(obj);
  const isConcatArray = opts && opts.concat;
  let result: T = Object.assign({}, src);
  if (isObject(src) && isObject(dist)) {
    for (const [distKey, distValue] of Object.entries(dist)) {
      const targetValue = (src as any)[distKey];
      if (isConcatArray && Array.isArray(distValue) && Array.isArray(targetValue)) {
        (result as any)[distKey] = targetValue.concat(...distValue);
      }
      else if (isObject(distValue) && src.hasOwnProperty(distKey)) {
        (result as any)[distKey] = merge<T>(targetValue, distValue, opts);
      }
      else {
        Object.assign((result as any), {[distKey]: distValue});
      }
    }
  }
  return result as T;
};

export default merge;